import React from 'react';
import styled from 'styled-components';
import { Text } from 'components/styled/ui';

const onlyUnique = (value, index, self) => { 
  return self.indexOf(value) === index;
}

const FileTypes = ({ documents }) => {
  const fileTypes = documents.map((document, index) => {
    const doc = document.split('.');
    return doc[doc.length - 1];
  });

  const filterArr = fileTypes.filter(onlyUnique);

  return (
    <Content className="fileTypes">
      {filterArr.map((fileType, index) => (
        <Text.span uppercase size={12} key={index}>
          {fileType}
        </Text.span>
      ))}
    </Content>
  );
};

export default FileTypes;

const Content = styled.div`
  display: block;

  > span {
    background-color: #ebebeb;
    padding: 4px 12px;
    border-radius: 12px;
    display: inline-block;
    &:not(:last-child) {
      margin-right: 6px;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/layouts/fileTypes/fileTypes.js